import "../vendor/calendar.min.js";
import FuiModuleModifier from "./fui-module";

export default class FuiCalendarModifier extends FuiModuleModifier {
  override semanticModuleName = "calendar";
}
